import type { AppEnvType } from '../app-env';
import { getAppEnv } from '../app-env';

import { analyticsVars, type IAnalyticsVars } from './analytics';
import { authVars, type IAuthVars } from './auth';
import { billingVars, type IBillingVars } from './billing';
import { elevenLabsVars, type IElevenLabsVars } from './elevenlabs';
import { emailVars, type IEmailVars } from './email';
import { type IIdentityVars, identityVars } from './identity';
import { type IRevenueCatVars, revenueCatVars } from './revenuecat';
import { type IS3Vars, s3Vars } from './s3';
import { type ISentryVars, sentryVars } from './sentry';
import { type ISlackVars, slackVars } from './slack';
import { type ITelegramVars, telegramVars } from './telegram';
import { type IUrlVars, urlVars } from './url';

function getVarsByEnv<T>(varsByEnv: Record<AppEnvType, T>): T {
  return varsByEnv[getAppEnv()];
}

export interface IVarsCollection {
  analytics: IAnalyticsVars;
  auth: IAuthVars;
  billing: IBillingVars;
  elevenLabs: IElevenLabsVars;
  email: IEmailVars;
  identity: IIdentityVars;
  revenueCat: IRevenueCatVars;
  s3: IS3Vars;
  sentry: ISentryVars;
  slack: ISlackVars;
  telegram: ITelegramVars;
  url: IUrlVars;
}

export const vars: IVarsCollection = {
  get analytics(): IAnalyticsVars {
    return getVarsByEnv(analyticsVars);
  },
  get auth(): IAuthVars {
    return authVars;
  },
  get billing(): IBillingVars {
    return billingVars;
  },
  get elevenLabs(): IElevenLabsVars {
    return elevenLabsVars;
  },
  get email(): IEmailVars {
    return getVarsByEnv(emailVars);
  },
  get identity(): IIdentityVars {
    return identityVars;
  },
  get revenueCat(): IRevenueCatVars {
    return getVarsByEnv(revenueCatVars);
  },
  get s3(): IS3Vars {
    return getVarsByEnv(s3Vars);
  },
  get sentry(): ISentryVars {
    return sentryVars;
  },
  get slack(): ISlackVars {
    return getVarsByEnv(slackVars);
  },
  get telegram(): ITelegramVars {
    return telegramVars;
  },
  get url(): IUrlVars {
    return getVarsByEnv(urlVars);
  },
};
